// @ts-strict-ignore
import type { ActionContext } from 'vuex'
import type { ActionClass, Dictionary, Filter, Pagination, SearchState } from '../../../models'
import type {
  SearchResponse,
  SearchService,
} from '../../../modules/search/services/types/search-service'
import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'

export class SearchAction implements ActionClass {
  static async execute(
    this: void,
    _actionContext: ActionContext<SearchState, any>,
    payload: {
      query: string
      filters: Dictionary<Filter>
      pagination: Pagination
      params?: Dictionary
      debug?: boolean
    },
  ): Promise<SearchResponse> {
    const searchService = CONTAINER.get<SearchService>(TYPES.SearchService)
    return searchService.search(payload)
  }
}
